export default function AutoComplete(props) {
  const clickHandler = (e, value) => {
    e.preventDefault();
    const _target = { name: props.name, value: value };
    const _event = { target: _target };
    if (props.clickHandler) props.clickHandler(_event, value);
  };

  return (
    <div className="suggestionBox">
      <ul className="suggestions">
        {props.suggestions.map((suggestion, index) => (
          <li
            key={index}
            id={"row - " + index}
            onClick={(e) => clickHandler(e, suggestion)}
          >
            {suggestion}
          </li>
        ))}
      </ul>
    </div>
  );
}
